/* eslint-disable max-len */
import React from 'react';

function Logo(props) {
  return (
    <svg
      className={`logo ${props.class}`}
      xmlns="http://www.w3.org/2000/svg"
      width="240"
      height="60"
      fill="none"
      viewBox="0 0 240 60"
    >
      <g clipPath="url(#clip0)">
        <g className="letters">
          <path
            fill={props.fill || 'url(#paint2_linear)'}
            stroke="#101F1F"
            strokeWidth="1.4"
            d="M59.84 49.96h15.18c.318 0 .543-.211.543-.542v-6.83h9.425c4.938 0 7.598-2.715 7.598-7.586V22.85c0-4.884-2.66-7.582-7.598-7.582H59.84c-.331 0-.543.212-.543.542v33.608c0 .33.212.542.543.542zm15.604-16.917v-8.247h.82v8.247h-.82zm45.433-17.775H99.409c-.265 0-.49.106-.596.423l-5.361 21.257v12.47c0 .33.212.542.543.542h15.236c.318 0 .543-.211.543-.542v-6.83h.754v6.83c0 .33.212.542.543.542h15.234c.331 0 .542-.211.542-.542v-12.47l-5.321-21.257c-.106-.317-.318-.423-.649-.423zm-11.05 9.528h.648l.106 9.981h-.86l.106-9.98zm17.889-8.986v33.608c0 .33.212.542.542.542h15.184c.318 0 .543-.211.543-.542V15.81c0-.33-.225-.542-.543-.542h-15.184c-.33 0-.542.212-.542.542zm17.674 34.15h14.098c.318 0 .543-.211.543-.542v-4.885l-3.415-7.042h.595l6.5 12.086c.159.278.331.383.596.383h13.287c.318 0 .543-.211.543-.542V15.81c0-.33-.225-.542-.543-.542h-14.201c-.278 0-.489.212-.489.542v4.87l3.309 6.724h-.662l-6.341-11.766c-.159-.264-.37-.37-.595-.37H145.39c-.331 0-.542.212-.542.542v33.608c0 .33.211.542.542.542zm59.201-34.692h-25.045c-.331 0-.543.212-.543.542v12.137c0 .33.212.542.543.542h4.394v20.929c0 .33.212.542.53.542h15.236c.278 0 .49-.211.49-.542V28.489h4.395c.331 0 .543-.212.543-.542V15.81c0-.331-.212-.543-.543-.543zM239.4 27.02v-4.17c0-4.884-2.714-7.582-7.598-7.582h-25.257c-.331 0-.543.212-.543.542v33.608c0 .33.212.542.543.542h15.236c.318 0 .543-.211.543-.542V38.139l.754.874v10.405c0 .33.212.542.543.542h15.236c.331 0 .543-.211.543-.542v-12.8l-3.64-3.522c2.224-1.138 3.64-2.978 3.64-6.076zm-16.322 3.31h-.754v-5.534h.754v5.533z"
          ></path>
        </g>
        <g className="roller">
          <path
            fill="#101F1F"
            d="M49.095 6.25h4.085a2.738 2.738 0 012.735 2.735V50.99a2.738 2.738 0 01-2.735 2.735h-1.89v1.22a2.712 2.712 0 01-2.711 2.709h-.34a2.715 2.715 0 01-2.71-2.711v-1.218h-1.89a2.74 2.74 0 01-2.735-2.735V8.985a2.737 2.737 0 012.734-2.735h4.046c-.135-1.705-1.549-3.055-3.288-3.055h-5.51c-1.416 0-2.679.903-3.137 2.245L28.762 25.88a6.716 6.716 0 01-6.01 4.532v3.114c0 .37-.29.678-.661.699l-16.804.879A5.294 5.294 0 010 29.813c0-2.915 2.372-5.287 5.324-5.284l16.767.879c.37.018.662.325.662.696V29a5.31 5.31 0 004.689-3.572l6.986-20.44A4.712 4.712 0 0138.886 1.8h5.51a4.716 4.716 0 014.699 4.45zm-2.168 47.475v1.218c0 .725.59 1.316 1.313 1.316h.339c.725 0 1.316-.59 1.316-1.316v-1.218h-2.968z"
          ></path>
          <path
            fill="#101F1F"
            d="M22.789 30.387V33.5c0 .371-.291.678-.662.7l-16.804.878a5.294 5.294 0 01-5.287-5.29c0-2.914 2.372-5.286 5.324-5.284l16.767.88c.37.018.662.325.662.695v2.897c.04-.003-.04.02 0 .016v1.419c-.047.003.047-.026 0-.024z"
          ></path>
          <path
            fill="url(#paint0_linear)"
            d="M22.789 30.387V33.5c0 .371-.291.678-.662.7l-16.804.878a5.294 5.294 0 01-5.287-5.29c0-2.914 2.372-5.286 5.324-5.284l16.767.88c.37.018.662.325.662.695v2.897c.04-.003-.04.02 0 .016v1.419c-.047.003.047-.026 0-.024z"
          ></path>
          <path
            fill="#101F1F"
            d="M53.175 6.212h-9.541a2.737 2.737 0 00-2.735 2.735v42.005a2.74 2.74 0 002.735 2.735h9.541a2.738 2.738 0 002.735-2.735V8.947a2.738 2.738 0 00-2.734-2.735z"
          ></path>
          <path
            fill="url(#paint1_linear)"
            d="M53.175 6.212h-9.541a2.737 2.737 0 00-2.735 2.735v42.005a2.74 2.74 0 002.735 2.735h9.541a2.738 2.738 0 002.735-2.735V8.947a2.738 2.738 0 00-2.734-2.735z"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="13.449"
          x2="13.237"
          y1="25.092"
          y2="31.668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#415252"></stop>
          <stop offset="0.391" stopColor="#4E5555"></stop>
          <stop offset="1" stopColor="#101F1F"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="55.969"
          x2="44.938"
          y1="29.944"
          y2="29.944"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#415252"></stop>
          <stop offset="0.438" stopColor="#4E5555"></stop>
          <stop offset="1" stopColor="#101F1F"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="215.7"
          x2="115.5"
          y1="-12.3"
          y2="92.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.068" stopColor="#00829C"></stop>
          <stop offset="0.198" stopColor="#4BD8DC"></stop>
          <stop offset="0.344" stopColor="#00AEC8"></stop>
          <stop offset="0.464" stopColor="#D5DA00"></stop>
          <stop offset="0.547" stopColor="#E9671A"></stop>
          <stop offset="0.63" stopColor="#F96868"></stop>
          <stop offset="0.771" stopColor="#00AEC8"></stop>
          <stop offset="0.885" stopColor="#4BD8DC"></stop>
          <stop offset="1" stopColor="#00829C"></stop>
        </linearGradient>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H240V60H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Logo;
